import { createFileRoute } from "@tanstack/react-router";
import { ScheduleLandingPage, scheduleSeoHead } from "@/components/schedule-landing-page";
import { AGENCY_LP_DESCRIPTION, AGENCY_LP_SHARED } from "@/lib/lp-schedule-agency";

/** Control arm of the headline test — see `lp.schedule-agency-b.tsx`. */

const LP_PATH = "/lp/schedule-agency";
// Short enough that " — Axy.digital" still fits inside the SERP truncation.
const LP_TITLE = "Launch a $3,000/mo GEO Service, No New Hires";

const H1 =
  "Use this to increase AI traffic for your clients in 90 days, or get your money back*.";

export const Route = createFileRoute("/lp/schedule-agency")({
  head: () =>
    scheduleSeoHead({ path: LP_PATH, title: LP_TITLE, description: AGENCY_LP_DESCRIPTION }),
  component: LandingPage,
});

function LandingPage() {
  return <ScheduleLandingPage title={H1} {...AGENCY_LP_SHARED} />;
}
